import React, {useEffect} from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { FormControlLabel, Radio } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
// Form related
import { Field } from 'formik';
import {CheckboxWithLabel, RadioGroup, Select} from 'formik-material-ui';
import { DatePicker } from 'formik-material-ui-pickers';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter";
import AddressInput from "../../../components/AddressInput/AddressInput";
import fieldData from '../FormModel/fieldData.js';

import connectionFormStyle from "../../../assets/jss/material-dashboard-react/views/connectionFormStyle";

const state = fieldData.state;
const useStyles = makeStyles(connectionFormStyle);

export default function BillingDetails(props) {
    const [showBankDetails, setShowBankDetails] = React.useState(false);
    const [showCardDetails, setShowCardDetails] = React.useState(false);
    const [showBillEmail, setShowBillEmail] = React.useState(false);
    const [showBillPaper, setShowBillPaper] = React.useState(false);
    const {formField, setFieldValue, values} = props;
    const classes = useStyles();

    useEffect(() => {
        setFieldValue(formField.billing_address.fields.street.name, values[formField.current_trading_address.fields.street.name]);
        setFieldValue(formField.billing_address.fields.state.name, values[formField.current_trading_address.fields.state.name]);
        setFieldValue(formField.billing_address.fields.postcode.name, values[formField.current_trading_address.fields.postcode.name]);
    }, []);

    const onClick = (event) => {
        if( event.target.name === formField.debit_from_bank.name ) {
            setShowBankDetails(wasOpened => !wasOpened);
        }
        else if( event.target.name === formField.debit_from_card.name ) {
            setShowCardDetails(wasOpened => !wasOpened);
        }
        else if( event.target.name === formField.send_email_bill.name ) {
            setShowBillEmail(wasOpened => !wasOpened);
        }
        else if( event.target.name === formField.send_paper_bill.name ) {
            setShowBillPaper(wasOpened => !wasOpened);
        }
    };

    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>5 | Billing Account Details</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                    <h4>How would you like to view or receive your monthly Vodafone bill?</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.send_email_bill.name}
                                        id={formField.send_email_bill.name}
                                        type="checkbox"
                                        onClick={onClick}
                                        Label={{ label: formField.send_email_bill.label }}
                                    />
                                    { showBillEmail ?
                                        <Field
                                            component={CustomInput}
                                            labelText={formField.bill_email.label}
                                            name={formField.bill_email.name}
                                            id={formField.bill_email.name}
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                type: "email"
                                            }}
                                        />
                                    : null }
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.send_paper_bill.name}
                                        id={formField.send_paper_bill.name}
                                        type="checkbox"
                                        onClick={onClick}
                                        Label={{ label: formField.send_paper_bill.label }}
                                    />
                                    { showBillPaper ?
                                        <AddressInput formField={formField.billing_address} classes={classes} states={state} />
                                    : null }
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.view_bill_online.name}
                                        id={formField.view_bill_online.name}
                                        type="checkbox"
                                        Label={{ label: formField.view_bill_online.label, className: classes.checkBoxText }}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    <h4>Your monthly Vodafone bill will be set up to be direct debit from?</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.debit_from_bank.name}
                                        id={formField.debit_from_bank.name}
                                        type="checkbox"
                                        onClick={onClick}
                                        Label={{ label: formField.debit_from_bank.label }}
                                    />
                                    { showBankDetails ?
                                        <FormGroup>
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.bank_bsb_no.label}
                                                name={formField.bank_bsb_no.name}
                                                id={formField.bank_bsb_no.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.bank_acct_no.label}
                                                name={formField.bank_acct_no.name}
                                                id={formField.bank_acct_no.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.bank_institution.label}
                                                name={formField.bank_institution.name}
                                                id={formField.bank_institution.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.bank_branch.label}
                                                name={formField.bank_branch.name}
                                                id={formField.bank_branch.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.bank_acct_name.label}
                                                name={formField.bank_acct_name.name}
                                                id={formField.bank_acct_name.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                        </FormGroup>
                                    : null }
                                    <h4>OR</h4>
                                    <Field
                                        component={CheckboxWithLabel}
                                        name={formField.debit_from_card.name}
                                        id={formField.debit_from_card.name}
                                        type="checkbox"
                                        onClick={onClick}
                                        Label={{ label: formField.debit_from_card.label }}
                                    />
                                    { showCardDetails ?
                                        <FormGroup>
                                            <FormControl component="fieldset" className={classes.formControl + " " + classes.itemSpacer}>
                                                <FormLabel component="legend">{formField.card_type.label}</FormLabel>
                                                <Field component={RadioGroup} name={formField.card_type.name} className={classes.formGroupHorizontal}>
                                                    <FormControlLabel
                                                        value={formField.card_type.fields.mastercard.name}
                                                        control={<Radio />}
                                                        label={formField.card_type.fields.mastercard.label}
                                                    />
                                                    <FormControlLabel
                                                        value={formField.card_type.fields.visa.name}
                                                        control={<Radio />}
                                                        label={formField.card_type.fields.visa.label}
                                                    />
                                                    <FormControlLabel
                                                        value={formField.card_type.fields.amex.name}
                                                        control={<Radio />}
                                                        label={formField.card_type.fields.amex.label}
                                                    />
                                                    <FormControlLabel
                                                        value={formField.card_type.fields.diners.name}
                                                        control={<Radio />}
                                                        label={formField.card_type.fields.diners.label}
                                                    />
                                                </Field>
                                            </FormControl>
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.card_number.label}
                                                name={formField.card_number.name}
                                                id={formField.card_number.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                            <Field
                                                component={CustomInput}
                                                labelText={formField.cardholder_name.label}
                                                name={formField.cardholder_name.name}
                                                id={formField.cardholder_name.name}
                                                formControlProps={{
                                                    fullWidth: true
                                                }}
                                            />
                                            <Field
                                                component={DatePicker}
                                                format="DD/MM/yyyy"
                                                name={formField.card_expiry_date.name}
                                                id={formField.card_expiry_date.name}
                                                label={formField.card_expiry_date.label}
                                                disablePast={true}
                                                className={classes.itemSpacer + " " + classes.underline}
                                            />
                                        </FormGroup>
                                    : null }
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                        <CardFooter>
                            &nbsp;
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}